import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatNavigation = createCustomElementWrapper('kat-navigation', 'KatNavigation', {}, {}, [
    'label',
]);
